/**************************************************
 * Nombre:       IngresoTexto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid2, InputAdornment, TextField} from "@mui/material";
import {Brightness1} from "@mui/icons-material";
import {useState} from "react";
import {LoadingButton} from "@mui/lab";


const IngresoTextoBarraBusqueda = ({
                                       props,
                                       nombre,
                                       dato,
                                       Icono = Brightness1,
                                       requerido = false,
                                       size = 'small',
                                       type = 'text',
                                       editable = true,
                                       ejemplo = false,
                                       funcionBuscar = null,
                                       Tarjeta = <></>,
                                       nombreIndex = ''
                                   }) => {
    const {register, errors, getValues, setValue} = props
    const [items, setItems] = useState([])
    const [cargando, setCargando] = useState(false)

    const accionFuncion = async () => {

        let palabra = getValues(dato)
        if (palabra && funcionBuscar) {
            setCargando(true)
            let arr = await funcionBuscar({nombreIndex: nombreIndex, palabra: palabra})
            setItems(arr)
            setCargando(false)
        }

    }

    const seleccionar = (it) => {

        for (let clave in it) {
            console.log(it[clave]);
            setValue(clave, it[clave])
        }
        setItems([])
    }


    return (

        <Grid2
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                <TextField
                    placeholder={ejemplo}
                    slotProps={{
                        input: {
                            startAdornment: (

                                <InputAdornment position="start">
                                    <Icono color={'primary'}/>
                                </InputAdornment>
                            ),
                            endAdornment: (
                                <InputAdornment position="end">
                                    <LoadingButton
                                        loading={cargando}
                                        variant={'contained'}
                                        onClick={() => accionFuncion()}
                                    >Buscar</LoadingButton>
                                </InputAdornment>
                            ),
                            disableUnderline: true,
                        },
                        inputLabel: {
                            sx: {marginLeft: -1}
                        }
                    }
                    }
                    // color={'info'}
                    disabled={!editable}
                    fullWidth
                    size={size}
                    label={nombre}
                    type={type}
                    {...register(dato, {required: requerido})}
                    error={!!errors[dato]}
                    helperText={errors[dato]?.message}

                />
            </Grid2>

            <Grid2 container size={{xs: 12, sm: 12, md: 12}}>
                {items.map((it, index) => {
                    return (
                        <Grid2 key={`EW${index}`} container size={{xs: 12, sm: 12, md: 12}} sx={{marginTop: 2}}>
                            <Tarjeta item={it} click={seleccionar}/>
                        </Grid2>
                    )
                })}
            </Grid2>

        </Grid2>

    )

}
export default IngresoTextoBarraBusqueda